import './common/pre-init';
import './common/hpe-wc-module';

import 'core/dependencies';
import 'core/helpers/bf-cache-fix';

import {onDocumentReady} from '@exadel/esl/modules/esl-utils/dom/ready';

import {debug} from 'core/log';
import {initComponent} from '../../core/ui/helpers/component';
import {initCore} from './legacy.base.init';

import {ChatApi} from 'hpe-chats/core/api';

/*
 * Application start
*/
onDocumentReady(function () {
  debug('System: Start components initialization.');

  initCore();

  // Catalog initialization
  initComponent(require('catalog/catalog.init'));

  // CHATS
  ChatApi.load()
    .catch(() => debug('Problem with Chat API loading'));

  // END
  debug('System: All components were initialized.');
});
